import { PackageProviderName } from 'data/ppoints/constants';
import { SelectAggregatorProvidersModal } from 'features/shipping-provider/selector/simplified/components/SelectAggregatorProvidersModal';
import useModal from 'hooks/modals/useModal';
import { AggregatorPackageProvider } from 'models/ppoints/CountryWithAggregatedProviders';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import PackageProviderService from 'services/settings/ppoints/PackageProviderService';

export const useSelectAggregatorProvidersModal = () => {
    const { t } = useTranslation();
    const { setModal, closeModal } = useModal();

    const openSelectAggregatorProvidersModal = useCallback(
        (
            aggregator: AggregatorPackageProvider,
            selectedProviderNames: PackageProviderName[],
            onSave: (providerNames: PackageProviderName[]) => void
        ) => {
            setModal({
                title: t('SHIPPING_PROVIDERS.AGGREGATOR_MODAL.TITLE', {
                    aggregator: PackageProviderService.getAggregatorDisplayName(aggregator.aggregator.name),
                }),
                component: (
                    <SelectAggregatorProvidersModal
                        aggregator={aggregator}
                        selectedProviderNames={selectedProviderNames}
                        onSave={(providerNames) => {
                            onSave(providerNames);
                            closeModal();
                        }}
                        onCancel={closeModal}
                    />
                ),
                variant: 'small',
                padding: '0',
            });
        },
        [setModal, closeModal, t]
    );

    return { openSelectAggregatorProvidersModal };
};
